import { HmModelRest } from './abstract_model';
import * as _ from 'lodash-es';

export let sections = [
    { enum: ['menu_home'], description: 'Menu home' },
    { enum: ['menu_agenda'], description: 'Menu agenda' },
    { enum: ['menu_prenotazioni'], description: 'Menu prenotazioni' },
    { enum: ['menu_info'], description: 'Menu info' },
    { enum: ['info_glossario'], description: 'Info glossario' },
    { enum: ['menu_strutture'], description: 'Menu strutture' },
    { enum: ['menu_fascicolosanitario'], description: 'Menu fascicolo sanitario' },
    { enum: ['menu_community'], description: 'Menu community' },
    { enum: ['menu_profilo'], description: 'Menu profilo' },
    { enum: ['verifica_peso'], description: 'Verifica peso' },
    { enum: ['menu_impostazioni'], description: 'Menu impostazioni' },
    { enum: ['menu_comunicazioni'], description: 'Menu comunicazioni' },
    { enum: ['menu_preference'], description: 'Menu preference' },
    { enum: ['esami#'], description: 'Esami' },
    { enum: ['macrotemi#'], description: 'Macrotemi' },
    { enum: ['categorie#'], description: 'Categorie' },
    { enum: ['sottocategorie#'], description: 'Sottocategorie' },
    { enum: ['informazioni#'], description: 'Informazioni' },
    { enum: ['strutture#'], description: 'Strutture' },
    { enum: ['menu_edit_profilo'], description: 'Menu edit profilo' },
];


export let sectionsFormly = [
    { value: 'menu_home', description: 'Menu home' },
    { value: 'menu_agenda', description: 'Menu agenda' },
    { value: 'menu_prenotazioni', description: 'Menu prenotazioni' },
    { value: 'menu_info', description: 'Menu info' },
    { value: 'info_glossario', description: 'Info glossario' },
    { value: 'menu_strutture', description: 'Menu strutture' },
    { value: 'menu_fascicolosanitario', description: 'Menu fascicolo sanitario' },
    { value: 'menu_community', description: 'Menu community' },
    { value: 'menu_profilo', description: 'Menu profilo' },
    { value: 'verifica_peso', description: 'Verifica peso' },
    { value: 'menu_impostazioni', description: 'Menu impostazioni' },
    { value: 'menu_comunicazioni', description: 'Menu comunicazioni' },
    { value: 'menu_preference', description: 'Menu preference' },
    { value: 'esami#', description: 'Esami' },
    { value: 'macrotemi#', description: 'Macrotemi' },
    { value: 'categorie#', description: 'Categorie' },
    { value: 'sottocategorie#', description: 'Sottocategorie' },
    { value: 'informazioni#', description: 'Informazioni' },
    { value: 'strutture#', description: 'Strutture' },
    { value: 'menu_edit_profilo', description: 'Menu edit profilo' },
];





export class Rimando extends HmModelRest {

    public rimando: string;

    //public categoria_rimando: string;

    //public ID_categoria_rimando: number;

    
    get categoria_rimando(): string {
        if (this.rimando && this.rimando.indexOf('#') != -1) {
            const categoria_rimando = this.rimando.split('#')[0];
            return categoria_rimando + '#';
        } else {
            return this.rimando;
        }
    }

    set categoria_rimando(rim_cat) {
        if (rim_cat && rim_cat.indexOf('#') != -1)
            this.rimando = rim_cat + this.ID_categoria_rimando;
        else this.rimando = rim_cat;
    }

    get ID_categoria_rimando(): number {
        if (this.rimando && this.rimando.indexOf('#') != -1) {
            return parseInt(this.rimando.split('#')[1], 10);
        } else {
            return null;
        }
    }

    set ID_categoria_rimando(rim_cat_enum) {
        if (rim_cat_enum && this.categoria_rimando.indexOf('#') != -1) {
            this.rimando = this.categoria_rimando + "#" + rim_cat_enum;
        } else {
            this.rimando = this.categoria_rimando;
        }
    }

    /*get categoria_rimando_list_number(): number {
        return sections.indexOf(this.getObjectFromCategoriaRimando(this.categoria_rimando));
    }

    set categoria_rimando_list_number(rim_cat_enum_list) {
        this.rimando = this.categoria_rimando + rim_cat_enum_list;
    }

    getObjectFromCategoriaRimando = function (
        categoria_rimando: string,
    ): any {
        return _.find(sections, { enum: [categoria_rimando] });
    };

    getTitleFromCategoriaRimando = function (
        categoria_rimando: string,
    ): string {
        const object = this.getObjectFromCategoriaRimando(categoria_rimando);
        return object ? object.description : null;
    };*/
}
